import React from 'react';
import CardWithSite from '../CardWithSite/index';
import Pergunta from '../../../img/pergunta.svg';
import Design from '../../../img/design-do-site.svg';
import redirectTo from '../../../services/loggedRedirectTo';
import { useHistoryPushExact } from '../../../services/hooks/UseHistoryPush';
import { StyledBox } from './style';


const WithSite = () => (
	<div style={{ padding: '0 0' }}>
		<div className="row" style={{ marginBottom: '1px', padding: '0 0' }}>
			<StyledBox className="col-12 col-xl-6">
				<CardWithSite
					icon={Design}
					altIcon=""
					titleIcon="Design"
					titleCaps="Editar meu site"
					text="Para editar seu site, clique no botão abaixo para entrar na Plataforma de sites da Webmotors"
					textButton="Editar site"
					buttonOnClick={redirectTo.sites}
					testId="edit-site"
				/>
			</StyledBox>
			<StyledBox className="col-12 col-xl-6">
				<CardWithSite
					icon={Pergunta}
					altIcon=""
					titleIcon="Ask"
					titleCaps="Fale conosco"
					text="Está com problemas? Clique no botão abaixo e abra um chamado para que possamos resolver!"
					textButton="Abrir chamado"
					buttonOnClick={() => useHistoryPushExact('/site/ticket')}
					testId="open-ticket"
				/>
			</StyledBox>
		</div>
	</div>
);

export default WithSite;
